 
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#0056B7',
    darken1: colors.purple.darken2,
  },
  success: {
      base: '#FF6100',
      darken1: colors.purple.darken2,
  },
  flexiappsecondary: '#B9CADD', 
  anchor: '#1976d2', 
  flexiapptitle: '#0099CC',
  light: '#FEFEFE'
}